import AirDatepicker from 'air-datepicker';
import localeRu from 'air-datepicker/locale/ru';
import localeUk from 'air-datepicker/locale/uk';
import localeEn from 'air-datepicker/locale/en';
import 'air-datepicker/air-datepicker.css';

function getQueryParam(name) {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

const [categoryDropdownBtnEl, dateDropdownBtnEl] = document.querySelectorAll('.dropdown__btn');
const filtersForm = document.querySelector('.search-page-form');

let categoryId, searchValue;
let date = getQueryParam('date') || '';

const handleUpdateUrlParams = () => {
  const newParams = new URLSearchParams(window.location.search);
  const url = new URL(window.location.href)
  url.search = newParams.toString();

  if (categoryId) {
    newParams.set('category', categoryId);
  } else {
    newParams.delete('category');
  }

  if (date) {
    newParams.set('date', date);
  } else {
    newParams.delete('date');
  }

  if (searchValue) {
    newParams.set('search', searchValue);
  } else {
    newParams.delete('search');
  }

  url.search = newParams.toString();

  window.history.pushState({}, '', url);
}

filtersForm.addEventListener('submit', (e) => {
  e.preventDefault();
  const searchInput = filtersForm.querySelector('.search__input');
  searchValue = searchInput.value.trim();
  handleUpdateUrlParams();
  window.location.reload();
});

// Toggle dropdown content on dropdown button click
[categoryDropdownBtnEl, dateDropdownBtnEl].forEach((btn) => {
  btn.addEventListener('click', () => {
    btn.classList.toggle('dropdown__btn_active');
    const dropdownContent = btn.nextElementSibling;

    dropdownContent.classList.toggle('dropdown-content_active');
  });
});

// HANDLE CATEGORIES START //
const categoryDropdownContent = categoryDropdownBtnEl.nextElementSibling;
const btnTextNode = categoryDropdownBtnEl.querySelector('.dropdown__btn-text');
let prevSelectedCategoryEl = null;

categoryDropdownContent.addEventListener('click', (e) => {
  if (e.target.classList.contains('dropdown__item')) {
    const optionItemEl = e.target;

    // remove selected class from previous selected category
    prevSelectedCategoryEl && prevSelectedCategoryEl.classList.remove('dropdown__item_selected');

    optionItemEl.classList.toggle('dropdown__item_selected');
    btnTextNode.textContent = optionItemEl.textContent;
    categoryId = optionItemEl.dataset.value;

    prevSelectedCategoryEl = optionItemEl;
    categoryDropdownBtnEl.classList.remove('dropdown__btn_active');
    categoryDropdownContent.classList.remove('dropdown-content_active');

    handleUpdateUrlParams();
  }
});
// HANDLE CATEGORIES END //


// HANDLE DATE START //
const LOCALES = new Map([
  ['ru', localeRu],
  ['uk', localeUk],
  ['en', localeEn]
]);
// get locale from URL prefix
// get URL path
const urlPath = window.location.pathname;
// get locale from URL path
const pathPart = urlPath.split('/')[1];

// check if pathPart is in LOCALES
let dateLocale;
if (LOCALES.has(pathPart)) {
  dateLocale = LOCALES.get(pathPart);
} else {
  dateLocale = LOCALES.get('uk');
}

const dateTextNode = dateDropdownBtnEl.querySelector('.dropdown__btn-text');
const datePickers = document.querySelectorAll('.datepicker');
datePickers.forEach((itm) => {
  new AirDatepicker(itm, {
    inline: true,
    prevHtml: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.5 15.833L6.66667 9.99967L12.5 4.16634" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
    nextHtml: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 15.833L13.3333 9.99967L7.5 4.16634" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
    locale: dateLocale,
    selectedDates: date ? [date] : [],
    onSelect({ datepicker, date: selectedDate }) {
      if (selectedDate) {
        const year = selectedDate.getFullYear();
        const month = String(selectedDate.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed, so we add 1
        const day = String(selectedDate.getDate()).padStart(2, '0');

        date = `${year}-${month}-${day}`;

        dateTextNode.textContent = date;
      } else {
        date = '';
        dateTextNode.textContent = ''
      }

      itm.classList.toggle('dropdown-content_active');
      dateDropdownBtnEl.classList.remove('dropdown__btn_active');
      handleUpdateUrlParams();
    },
    navTitles: {
      days: '<i>MMMM </i> &nbsp; <strong> yyyy</strong> ',
      // months: 'Select month of <strong>yyyy</strong>'
    },
  });
})

const dateDropdownBtnElMob = document.querySelector('.date-icon-mob');
const dateDropdownContentMob = document.querySelector('.datepicker ');
dateDropdownBtnElMob.addEventListener('click', () => {
  dateDropdownContentMob.classList.toggle('dropdown-content_active');
})


// HANDLE DATE END //